import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ClearPhoneVerificationResponse extends BackendResponse {}
export interface ClearPhoneVerificationParameters extends NextApiParams {}

export const clearPhoneVerification = withNextApi<
  ClearPhoneVerificationResponse,
  ClearPhoneVerificationParameters
>("/cvp/CvpClearPhoneVerification");
